import ApiEndPoints from "../Enums/ApiEndPoint.enum";

import axios from "./Configuration/apiConfiguration";

const getProducts = (Params: any) =>
    new Promise((resolve, reject) => {
        axios
            .get(`${ApiEndPoints.productsList}/User/${Params?.userId}?page=${Params?.page}`)
            .then((apiResponse) => {
                resolve({ success: true, data: apiResponse?.data?.data });
            })
            .catch((apiFailed) => {
                reject(apiFailed);
            });
    });

const getProductsFilter = (params: any) =>
    new Promise((resolve, reject) => {
        axios
            .post(`${ApiEndPoints.productsList}/Dealer?page=${params?.page}`, params)
            .then((apiResponse) => {
                resolve({ success: true, data: apiResponse?.data?.data });
            })
            .catch((apiFailed) => {
                reject(apiFailed);
            });
    });
export default { getProducts, getProductsFilter };
